import { useNavigate } from 'react-router-dom';

import Button from '../../../../reusable/button/button.component.jsx';

import {
  BlockWrapper,
  BlockButton,
  CenterWrapper,
  ButtonMeta
} from './button-display.styles.jsx';

const ButtonDisplay = ({ section }) => {
  const navigate = useNavigate();
  const { layout, buttons = [] } = section.metadata || {};

  const renderMeta = (btn) => (
    <ButtonMeta>
      <span>Type: {btn.linkType || 'N/A'}</span>
      <span>Link: {btn.link || 'N/A'}</span>
    </ButtonMeta>
  );

  const renderBlockButton = (btn, i) => {
    const isLastOdd = buttons.length % 2 === 1 && i === buttons.length - 1;
    const link = btn.link || '#';
    const text = btn.text || 'No Text';

    const content = (
      <>
        <BlockButton
          isLastOdd={isLastOdd}
          onClick={() => navigate(link)}
        >
          {text}
        </BlockButton>
        {renderMeta(btn)}
      </>
    );

    if (btn.linkType === 'external') {
      return (
        <a
          key={i}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          {content}
        </a>
      );
    }

    return (
      <div key={i} style={{ width: '100%' }}>
        {content}
      </div>
    );
  };

  const renderSingleButton = (btn, i) => {
    const link = btn.link || '#';
    const text = btn.text || 'No Text';

    const content = (
      <>
        <Button onClick={() => navigate(link)}>
          {text}
        </Button>
        {renderMeta(btn)}
      </>
    );

    if (btn.linkType === 'external') {
      return (
        <div key={i}>
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <Button>{text}</Button>
          </a>
          {renderMeta(btn)}
        </div>
      );
    }

    return (
      <div key={i} onClick={() => navigate(link)}>
        {content}
      </div>
    );
  };

  if (layout === 'block') {
    return (
      <BlockWrapper count={buttons.length}>
        {buttons.map(renderBlockButton)}
      </BlockWrapper>
    );
  }

  return (
    <CenterWrapper>
      {buttons.map(renderSingleButton)}
    </CenterWrapper>
  );
};

export default ButtonDisplay;